module.exports = __webpack_public_path__ + "img/Ellipse.9f58dfb3.svg";